import AppRoutes from "./pages/routes/routes";

const App = () => {
  return <AppRoutes />;
};

export default App;
